// extracted by mini-css-extract-plugin
module.exports = {"RoleLabel":"User_RoleLabel__1rOU_","roleLabel":"User_RoleLabel__1rOU_"};